class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M15 8.25v-3.5a3.504 3.504 0 0 0-3.5-3.5H1v7h3.232l1.79 2.683.422 2.958a1.005 1.005 0 0 0 .99.859H8.5a1.502 1.502 0 0 0 1.5-1.5v-3h3a2.002 2.002 0 0 0 2-2Zm-11-1H2v-5h2v5Zm10 1a1.001 1.001 0 0 1-1 1H9v4a.5.5 0 0 1-.5.5H7.434l-.455-3.183L5 7.599V2.25h6.5a2.503 2.503 0 0 1 2.5 2.5v3.5Z"></path></svg>';
  }
}
const t = "pi-thumbs-down";
customElements.get(t) || customElements.define(t, s);
export {
  s as default
};
